module.exports = __webpack_public_path__ + "static/media/tv-music.0d9fca99.svg";